import { useBackgroundContext } from '../../BackgroundContext/index.js';
export const useInputColors = ({ invalid, disabled }) => {
    const { backgroundType } = useBackgroundContext();
    const borderClsx = [
        backgroundType === 'main' && 'border border-line',
        backgroundType === 'surface' && 'border border-line',
        backgroundType === 'secondary' && 'border border-line-on-topbar',
    ];
    const focusClsx = [
        'focus:ring-1',
        'focus-within:ring-1 focus-within:ring-offset-0',
        !invalid && [
            (backgroundType === 'main' || backgroundType === 'surface') && [
                'focus:ring-focused focus:border-focused',
                'focus-within:ring-focused focus-within:border-focused',
            ],
            backgroundType === 'secondary' &&
                'focus:ring-line-on-topbar-pressed focus:border-line-on-topbar-pressed',
        ],
        invalid && [
            'focus:ring-line-negative focus:border-line-negative',
            'focus-within:ring-line-negative focus-within:border-line-negative',
        ],
    ];
    const placeholderClsx = [
        !invalid && [
            backgroundType === 'main' &&
                'placeholder:text-content-subdued placeholder:opacity-60',
            backgroundType === 'surface' &&
                'placeholder:text-content-subdued placeholder:opacity-60',
            backgroundType === 'secondary' &&
                'placeholder:text-content-on-topbar placeholder:opacity-60',
        ],
        invalid && 'placeholder:text-action-destructive',
    ];
    const iconClsx = [
        backgroundType === 'main' && 'text-content-subdued',
        backgroundType === 'surface' && 'text-content-subdued',
        backgroundType === 'secondary' && 'text-content-on-topbar',
    ];
    const backgroundClsx = [
        backgroundType === 'main' && 'bg-surface text-content-subdued',
        backgroundType === 'surface' && 'bg-surface text-content-subdued',
        backgroundType === 'secondary' && 'bg-topbar text-content-on-topbar',
    ];
    const invalidClsx = ['border-line-negative text-content-on-negative'];
    const disabledClsx = ['opacity-60 cursor-default'];
    const fontClsx = ['font-sans'];
    return {
        inputClsx: [
            'appearance-none',
            fontClsx,
            backgroundClsx,
            placeholderClsx,
            borderClsx,
            focusClsx,
            invalid && invalidClsx,
            disabled && disabledClsx,
        ],
        placeholderClsx,
        iconClsx,
        borderClsx,
        backgroundClsx,
        focusClsx,
        invalidClsx,
        disabledClsx,
        fontClsx,
    };
};
//# sourceMappingURL=useInputColors.js.map